import { http } from '../../config/axios'

export default function inativarCampanha(id: string): Promise<string> {
  return http
    .patch('api/campanha/inativar/' + encodeURIComponent(id))
    .then((res) => res.data as string)
    .catch((error) => {
      console.error('Erro inativar campanha', error)
      throw Error(error.response.data)
    })
}
